




import Vue from 'vue';
import SearchInstallations from '@/containers/search-installations';

export default Vue.extend({
  components: {
    SearchInstallations,
  },
});
